class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.id.replace('StickyAtc-', '');
    this.priceEl = document.getElementById(`StickyAtcPrice-${this.sectionId}`);
    this.button = document.getElementById(`StickyAtcButton-${this.sectionId}`);
    this.buttonLabel = this.button ? this.button.querySelector('span') : null;
    this.selects = Array.from(this.querySelectorAll('.sticky-atc__select'));

    const variantsScript = document.getElementById(`StickyAtcVariants-${this.sectionId}`);
    this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];

    // Section IDs on this theme are dynamic (e.g. "template--123__main"), not a
    // fixed "main" — find the real product form/button instead of hardcoding it.
    this.mainForm = document.querySelector('form[id^="product-form-"]');
    this.mainIdInput = this.mainForm ? this.mainForm.querySelector('input[name="id"]') : null;

    if (this.button && this.mainForm) {
      this.button.setAttribute('form', this.mainForm.id);
    }

    this.selects.forEach((select) => {
      select.addEventListener('change', this.handleOptionChange.bind(this));
    });

    // The main variant picker (e.g. a bundle's radio buttons) updates this
    // same hidden input and dispatches 'change' on it whenever the selection
    // changes there — listen so the sticky bar stays in sync in that
    // direction too, not just when the sticky bar's own select is used.
    if (this.mainIdInput) {
      this.mainIdInput.addEventListener('change', this.syncFromMain.bind(this));
    }

    this.observeAddToCartButton();
  }

  handleOptionChange() {
    const selectedOptions = this.selects.map((select) => select.value);
    const matchedVariant = this.variants.find((variant) =>
      variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
    );
    if (!matchedVariant) return;

    if (this.mainIdInput) {
      this.mainIdInput.value = matchedVariant.id;
      this.mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.updateDisplay(matchedVariant);
  }

  syncFromMain() {
    if (!this.mainIdInput) return;
    const matchedVariant = this.variants.find(
      (variant) => String(variant.id) === String(this.mainIdInput.value)
    );
    if (!matchedVariant) return;

    this.selects.forEach((select) => {
      const optionIndex = Number(select.dataset.optionIndex || 0);
      const value = matchedVariant.options[optionIndex];
      if (value !== undefined) select.value = value;
    });

    this.updateDisplay(matchedVariant);
  }

  updateDisplay(matchedVariant) {
    if (this.priceEl) {
      const hasDiscount =
        matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price;
      this.priceEl.innerHTML = hasDiscount
        ? `<s>${matchedVariant.compare_at_price_formatted}</s> ${matchedVariant.price_formatted}`
        : matchedVariant.price_formatted;
    }

    if (this.button) {
      this.button.disabled = !matchedVariant.available;
      if (this.buttonLabel) {
        this.buttonLabel.textContent = matchedVariant.available
          ? this.button.dataset.addLabel
          : this.button.dataset.soldOutLabel;
      }
    }
  }

  observeAddToCartButton() {
    const target = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!target || !('IntersectionObserver' in window)) {
      // Fail safe: if we can't find the real button to watch, show the bar
      // anyway rather than silently never appearing.
      if (!target) this.classList.add('sticky-atc--visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(target);
  }
}

customElements.define('sticky-atc-bar', StickyAtcBar);
